import { action, makeObservable, observable, reaction } from 'mobx';
import type { RoutingStore } from './RoutingStore';

export class HeaderStore {
  private readonly routingStore: RoutingStore;

  public isSticky: boolean = false;
  public searchCriteria: string = '';
  public isSearchInputFocused: boolean = false;

  constructor({ routingStore }: { routingStore: RoutingStore }) {
    makeObservable(this, {
      isSticky: observable,
      searchCriteria: observable,
      isSearchInputFocused: observable,
      setSearchCriteria: action,
      setIsSticky: action,
      setSearchInputFocused: action,
    });

    this.routingStore = routingStore;

    const criteria =
      this.routingStore.matchedRoute?.routeName === 'search' ? this.routingStore.matchedRoute?.params.criteria : '';

    this.setSearchCriteria(criteria);

    this.listenForRouteChanges();
  }

  private listenForRouteChanges() {
    reaction(
      () => this.routingStore.matchedRoute,
      () => {
        const isSearchRoute = this.routingStore.matchedRoute.routeName === 'search';

        if (!isSearchRoute && !this.isSearchInputFocused) {
          this.setSearchCriteria('');
        }
      },
    );
  }

  public get isLargeSearchInput(): boolean {
    return !this.isSticky;
  }

  setSearchCriteria = (value: string) => {
    this.searchCriteria = value;
  };

  setIsSticky = (value: boolean) => {
    this.isSticky = value;
  };

  setSearchInputFocused = (isFocused: boolean) => {
    this.isSearchInputFocused = isFocused;
  };
}
